import { render, staticRenderFns } from "./CreatePromoModal.vue?vue&type=template&id=1d9e5f6e"
import script from "./CreatePromoModal.vue?vue&type=script&lang=js"
export * from "./CreatePromoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports